import { cn } from '../cn';
import Button from '../Input2/Button';
import { General } from '../StrokeIcons';

export type TemplateBlockAddButtonPureProps = {
  onClick?: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
  className?: string;
};

export function TemplateBlockAddButtonPure({
  onClick,
  disabled,
  disabledTooltip,
  className,
}: TemplateBlockAddButtonPureProps) {
  return (
    <Button
      data-testid="template-block-add"
      text
      size="sm"
      textAlign="center"
      disabled={disabled}
      tooltip={disabled ? disabledTooltip : undefined}
      onClick={onClick}
      className={cn(
        'w-full justify-center rounded-none border-0 border-t border-dashed bg-transparent py-2',
        'border-lynch-300 text-lynch-700 dark:border-slate-700 dark:text-lynch-300',
        'hover:border-solid hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 dark:hover:border-blue-400 dark:hover:bg-blue-950 dark:hover:text-blue-300',
        'disabled:hover:border-dashed disabled:hover:border-lynch-300 disabled:hover:bg-transparent disabled:hover:text-lynch-700',
        className,
      )}>
      <span className="inline-flex items-center gap-1">
        <General.Plus className="size-3.5" />
        add step
      </span>
    </Button>
  );
}
